import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/** The type scale from UI.md lives in globals.css; tailwind-merge must know these are font sizes, not colours. */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        {
          text: ["body", "label", "caption", "micro", "menu", "lead", "page-title", "card-title", "card-subtitle", "kpi", "kpi-label", "table-head", "group-label", "reading", "chip"],
        },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
